// extracted by mini-css-extract-plugin
export default {"btn_box":"ErrorPage_btn_box__zFAk5"};